import React, { useState } from 'react'
import { CollapsibleContainer, Button } from '@corratech/pylot-ui'
import { FilterList } from './FilterList'
import { FilterBlockProps } from '../FilterTypes'
import { useTranslation } from 'next-i18next/pages'

import s from '../SidebarFilter/SidebarFilter.module.scss'

export const FilterBlock = (props: FilterBlockProps): JSX.Element | null => {
    const { t } = useTranslation(['plp'])
    const {
        items,
        availableValues,
        name,
        isHorizontal,
        applyFilter,
        requestVar,
        isLoading,
        showCount,
        currencyCode,
        iconOpen,
        iconClose,
        appliedSearchCritieria,
        appliedFilterData,
        showFilterCount,
        initialFilterAttribute
    } = props

    const [expand, setExpand] = useState(false)

    const getAppliedFilterCount = (requestVar: string) => {
        const count = appliedFilterData.filter(
            (filter) => filter.requestVar == requestVar
        ).length
        return count > 0 ? count : ''
    }

    const getFilterName = (name: string, requestVar: string) => {
        return (
            <>
                {t(name)}
                <span>
                    {showFilterCount && getAppliedFilterCount(requestVar)}
                </span>
            </>
        )
    }

    if (requestVar === 'color') return null
    if (requestVar === 'exclude_livesearch') return null

    return Array.isArray(items) ? (
        <li key={name}>
            {!isHorizontal && (
                <CollapsibleContainer
                    title={getFilterName(name || '', requestVar)}
                    isOpen={expand}
                    onOpen={() => setExpand(true)}
                    onClose={() => setExpand(false)}
                    classes={s['accordion']}
                    iconOpen={iconOpen}
                    iconClose={iconClose}
                >
                    <FilterList
                        items={items}
                        availableValues={availableValues}
                        requestVar={requestVar}
                        applyFilter={applyFilter}
                        isLoading={isLoading}
                        showCount={showCount}
                        currencyCode={currencyCode}
                        appliedSearchCritieria={appliedSearchCritieria}
                        appliedFilterData={appliedFilterData}
                        initialFilterAttribute={initialFilterAttribute}
                    />
                </CollapsibleContainer>
            )}
            {isHorizontal && (
                <div className={s['accordion']}>
                    <Button className={s['filter-head']} variant="link">
                        {getFilterName(name || '', requestVar)}
                    </Button>

                    <FilterList
                        items={items}
                        availableValues={availableValues}
                        requestVar={requestVar}
                        applyFilter={applyFilter}
                        isLoading={isLoading}
                        showCount={showCount}
                        currencyCode={currencyCode}
                        appliedSearchCritieria={appliedSearchCritieria}
                        isHorizontal={isHorizontal}
                        appliedFilterData={appliedFilterData}
                        initialFilterAttribute={initialFilterAttribute}
                    />
                </div>
            )}
        </li>
    ) : null
}
